import DayPickerInput from 'react-day-picker/DayPickerInput';
import moment from 'moment';
import { formatDate } from 'react-day-picker/moment';
import React, { useReducer } from 'react';
import CloseIcon from '../../assets/svg/close.svg'

import styles from './dataRange.css';
import CalendarIcon from '../../assets/svg/Calendar1.svg';
import { useSelector } from 'react-redux';

const initialState = {
    startDateFormatted: null,
    endDateFormatted: null,

    startDateText: '',
    endDateText: ''
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case 'ADD-DATA': {
            return { ...state, ...action.data };
        }
        default:
            return state;
    }
};

const initial = state => state;


const DataRange = ( { onDataRange, closeHandle } ) => {
    const [ data, reducerDispatch ] = useReducer( reducer, initialState, initial );
    const { startDateFormatted, endDateFormatted, showDataRange, startDateText, endDateText } = data;
    const { localization: { content } } = useSelector( state => state );


    const handleStartDayChange = ( modifiers ) => {
        let newData = moment( modifiers ).format( 'YYYY-M-D' );
        if ( newData > endDateFormatted ) {
            reducerDispatch( {
                type: 'ADD-DATA', data: {
                    startDateFormatted: null
                }
            } );
        } else {
            reducerDispatch( {
                type: 'ADD-DATA', data: {
                    startDateFormatted: newData
                }
            } );
        }
    };

    const handleEndDayChange = ( modifiers ) => {
        let newData = moment( modifiers ).format( 'YYYY-M-D' );
        if ( newData < startDateFormatted ) {
            reducerDispatch( {
                type: 'ADD-DATA', data: {
                    endDateFormatted: null
                }
            } );

        } else {
            reducerDispatch( {
                type: 'ADD-DATA', data: {
                    endDateFormatted: newData
                }
            } );
        }
    };

    const sendDataFilter = () => {
        const from = moment( startDateFormatted ).format( 'YYYY-MM-DD' );
        const to = moment( endDateFormatted ).format( 'YYYY-MM-DD' );
        if ( from && to ) {
            onDataRange( { from, to } );
        }

        const now = moment( startDateFormatted ); //todays date
        const end = moment( endDateFormatted ); // another date
        const duration = moment.duration( end.diff( now ) );
        const getMonth = duration.asMonths();
        const range = duration.asMonths() < 1 ? getMonth.toFixed( 1 ) : Math.round( getMonth );

        reducerDispatch( {
            type: 'ADD-DATA', data: {
                printRange: `for - ${ range } month`
            }
        } );
        closeHandle();
    };

    return (
        <div
            className={ styles.calendarRange }>
            <CloseIcon onClick={ closeHandle }/>
            <div className={ styles.calendarWrapper }>
                <div className={ styles.dataCalendar }>
                    <div className={ styles.dataItem }>
                        <p className={ styles.text }>start</p>
                        <DayPickerInput
                            className={ styles.DayPickerInput }
                            onDayChange={ handleStartDayChange }
                            formatDate={ formatDate }
                            value={ startDateFormatted === null ? `${ startDateText }` : startDateFormatted }
                        />
                    </div>
                    ——
                    <div className={ styles.dataItem }>
                        <p className={ styles.text }>end</p>
                        <DayPickerInput
                            className={ styles.DayPickerInput }
                            onDayChange={ handleEndDayChange }
                            formatDate={ formatDate }
                            value={ endDateFormatted === null ? `${ endDateText }` : endDateFormatted }
                        />
                    </div>
                </div>

                <nav className={ styles.calendarNavPanel }>
                    <div className={ styles.setButton } onClick={ sendDataFilter }>
                        <CalendarIcon className={ styles.icon }/>
                        <span>{ content.quiz.players.drop_btn_set_range }</span>
                    </div>
                </nav>
            </div>
        </div>
    );

};

export default DataRange;